// extracted by mini-css-extract-plugin
module.exports = {"skillTag":"n9w0x","skillTagSpan":"_2RGvr","skillTagTooltip":"_nwA_","deleteLoading":"xe1Mn"};